import type { ParticipationApiId } from "../shared/participation";

export const FEATURE_INTRO_SLIDE_IDS = [
  "kakuzuke",
  "twenty-doors",
  "ogiri",
  "love-advice",
] as const;

export type FeatureIntroSlideId = (typeof FEATURE_INTRO_SLIDE_IDS)[number];

export const SLIDE_IDS = [
  "program",
  ...FEATURE_INTRO_SLIDE_IDS,
  "participation",
  "countdown",
] as const;

export type SlideId = (typeof SLIDE_IDS)[number];

export interface DisplaySettings {
  readonly version: 3;
  readonly startAtJst: string;
  readonly apiId: ParticipationApiId;
  readonly enabledSlides: readonly SlideId[];
  readonly announcements: readonly string[];
  readonly countdownSoundEnabled: boolean;
  readonly requestFullscreen: boolean;
}

export interface SlideDefinition {
  readonly id: SlideId;
  readonly label: string;
  readonly description: string;
}
